import React from 'react';
import { View, Text, ScrollView, TouchableOpacity } from 'react-native';
import {FontInfo,  } from '../~Utilities/Constants';
import { Connection, ConnectionMkt, ConnectionOrd } from '../~Utilities/Connection';
import { Feather, FontAwesome, FontAwesome5, Foundation, Ionicons } from '@expo/vector-icons';
import Text2Eqv from '../C_Text/Text2Eqv';
import TextWithImage from '../C_Text/TextWithImage';
import { AccData } from '../~Utilities/Data';

/*   ---------------------------------------------------------------------   */

const DEFAULT_WIDTH   = 350;

/*   ---------------------------------------------------------------------   */

export interface IACCInfo
{
  bindEvent       : (onEvent    : (() => void),
                     bSubscribe : boolean) => void
}

/*   ====================================================================   */

interface IACCState
  {
  exit_conf_acc : string | undefined;
  exit_all      : boolean;
  }

/*   ====================================================================   */

export default class ACC extends React.Component<IACCInfo>
 {
   state                : IACCState = {exit_conf_acc: undefined, 
                                       exit_all:false}
   private  oTimeOut?   : NodeJS.Timeout;

   /*   -------------------------------------------------------------------   */

    constructor(props)
    {
    super(props);

    this.state = {exit_conf_acc: undefined, exit_all:false};

    this.Reset = this.Reset.bind(this);
    }

    /*   ---------------------------------------------------------------------   */

    componentDidMount()
    {
    }

    componentWillUnmount()
    {
    if (this.oTimeOut)
      {
      clearTimeout(this.oTimeOut);
      this.oTimeOut = undefined;
      }
    }

   /*   ---------------------------------------------------------------------   */

    componentDidUpdate()
    {
    }

   /*   ---------------------------------------------------------------------   */

   static GetPNLColor(oData : AccData)
   {
   if (oData.pnl_open == undefined ||
       (oData.pnl_open == 0 && 
        oData.net_qty  == 0))
     return('gray');
   else if (oData.pnl_open >= 0)
     return(FontInfo.sGreen);
   else //if (oData.pnl_open < 0)
     return('crimson');
   //else
   //  return('gray');
   }

   /*   ---------------------------------------------------------------------   */

   static GetPNLClosedColor(oData : AccData)
   {
   if (!oData.pnl_closed)
     return('gray');
   else if (oData.pnl_closed > 0)
     return(FontInfo.sGreen)
   else if (oData.pnl_closed < 0)
      return('crimson'); //red')
   else
      return('gray');
   }

   /*   ---------------------------------------------------------------------   */

   static GetPNLText(oData : AccData)
   {
   if (oData.pnl_open == undefined)
     return('')
   else
     return(oData.pnl_open + "")
   }

   /*   ---------------------------------------------------------------------   */

   static GetPNLClosedText(oData : AccData)
   {
   if (oData.pnl_closed == undefined)
     return('')
   else
     return(oData.pnl_closed + "")
   }

   /*   ---------------------------------------------------------------------   */

   static GetAccBalanceText(oData : AccData)
   {
   if (oData.acc_balance == undefined)
     return('');
   else
     return(oData.acc_balance + "");
   }

   /*   ---------------------------------------------------------------------   */

   static GetPosText(oData : AccData)
   {
   if (oData.open_net_qty == undefined)
     return('');
   else
     return(oData.open_net_qty);
   }

   /*   ---------------------------------------------------------------------   */

   static GetPosColor(oData : AccData)
   {
     if (oData.net_qty      == undefined || 
         oData.open_net_qty == undefined || 
         oData.open_net_qty == 0)
       return('gray');
      else if (Math.abs(oData.net_qty) < oData.open_net_qty)
        return('#bc4dff');
      else if (oData.net_qty < 0)
        return('hotpink');
      else
        return('dodgerblue');

      //else if (oData.fill)
    //  else if (oData.open_net_qty == 0)
    //    {
    //    if (oData.pnl_open == 0 || oData.pnl_open == undefined)
    //      return('gray');
    //    else
    //      return('#bc4dff'); //#b233ff //'#9f00ff');
    //    }
    //  else if (oData.net_qty > 0)
    //    return('dodgerblue');
    //  else
    //    return('hotpink');
   }

   /*   ---------------------------------------------------------------------   */

   static GetOrdColor(oData : AccData)
   {
     if (!oData.working_buys && !oData.working_sells)
       return('gray');
     else if (oData.working_buys && !oData.working_sells)
       return('dodgerblue');
     else if (!oData.working_buys && oData.working_sells)
       return('hotpink');
     else
       return('#bc4dff'); //#b233ff //'#9f00ff');
   }

   /*   ---------------------------------------------------------------------   */

   static GetOrderText(oData : AccData)
   {
     if (oData.working_buys == undefined && oData.working_sells == undefined)
       return ("");
     else
       return(oData.working_buys + "/" + oData.working_sells); //#b233ff //'#9f00ff');
   }

   /*   ---------------------------------------------------------------------   */

   Reset()
   {
   if (this.oTimeOut)
     {
     clearTimeout(this.oTimeOut);
     this.oTimeOut = undefined;
     }

     this.oTimeOut = setTimeout(() =>
       {
       clearTimeout(this.oTimeOut);
       this.oTimeOut = undefined;

       this.setState({
                      exit_conf_acc: undefined,
                      exit_all: false
                     });
       }, 3000);
   }

   /*   ---------------------------------------------------------------------   */

   render()
   {
    return(
      // <View style={{paddingTop:20, alignSelf:'center', flexDirection:'column', alignItems:'center',
      // backgroundColor:'transparent', borderRadius:20, paddingBottom:30, width:'100%', height:'100%',
      //  }}>

        // <ScrollView style={{width:'100%',}}>

        <View style={{flex:1,}}>

        <ScrollView scrollsToTop={true} 

        style={{//alignSelf:'center', //height:'50%',
                //marginTop:10, //flexDirection:'row', 
                backgroundColor:'transparent', 
                marginBottom:0, 
                }}
        contentContainerStyle={{alignItems:'flex-start', justifyContent:'flex-start'}}
        >

      <View style={{marginLeft:0, marginTop:20, alignSelf:'flex-start', flexDirection:'column', alignItems:'center',
                      backgroundColor:'rgba(255,255,255,.0)', borderRadius:20, }}>

        {
        Array.from(Connection.oAccStore.values()).map((oData, index) =>
        {
        return(
        // <View style={{marginLeft:45, backgroundColor:'transparent'}}>
        <View key={index} style={{marginLeft:45, backgroundColor:'transparent'}}>

        <View style={{width:DEFAULT_WIDTH - 100, backgroundColor:FontInfo.bDarkMode?'rgba(24,24,24,.7)':'rgba(255,255,255,.6)',
                    alignItems:'center', padding:5,
                    borderWidth:0, borderRadius:15, margin:5, marginBottom:20}}>


        <TouchableOpacity style={{alignItems:'center', justifyContent:'center', borderBottomLeftRadius:15,
                                borderTopLeftRadius:15, position:'absolute',
                                backgroundColor:this.state.exit_conf_acc==oData.acc_id || this.state.exit_all? "#ff355e": 
                                                              FontInfo.bDarkMode? FontInfo.sGrayTp : FontInfo.sBorder,
                                top:0, left:0, bottom:0, width:30}}
          onPress={()=>
            {
            if (this.state.exit_conf_acc == oData.acc_id)
              {
              ConnectionOrd.oConn?.Rq_CancelAllOrdersAcc(oData.key, "Main Menu, Cncl All & Fltn Button")
              ConnectionOrd.oConn?.Rq_ExitPositionAcc(oData.key, "Main Menu, Cncl All & Fltn Button");
              this.setState({exit_conf_acc:undefined, exit_all:false});
              }
            else
              {
              this.setState({exit_conf_acc:oData.acc_id, exit_all:false});
              this.Reset();
              }
            }}>
        {/* <AntDesign name="closecircle" size={30} color="#ef3038" /> */}
        <FontAwesome style={{marginLeft:2}} name="close" size={20} color={this.state.exit_conf_acc==oData.acc_id || this.state.exit_all? 'white':"#ff355e"} />
        </TouchableOpacity>

        <Text style={[ FontInfo.appStyles.txt_bold, {color:FontInfo.bDarkMode?'cornflowerblue':'royalblue', fontSize:FontInfo.iFontSize+2, }]}>{oData.acc_id}</Text>


        <Text style={{marginTop:5, color:FontInfo.sForeground, fontSize:FontInfo.iFontSize+2, fontWeight:'bold', }}>Balance</Text>
        <Text2Eqv style={ [FontInfo.appStyles.txt_bold, {color:'green', fontSize:FontInfo.iFontSize+2} ]}
                bindEvent={this.props.bindEvent}
                getText={()=>{ return( ACC.GetAccBalanceText(oData) ) }}
                />

        {/* <Text style={{marginTop:5, color:FontInfo.sForeground, fontSize:FontInfo.iFontSize+2, fontWeight:'bold', }}>ALTV</Text>
        <Text2Eqv style={ [FontInfo.appStyles.txt_bold, {color:'gray', fontSize:FontInfo.iFontSize+2} ]}
                bindEvent={this.props.bindEvent}
                getText={()=>{ return( oData.altv?.toFixed(2)) }}
                />                 */}

        <Text style={{marginTop:5, color:FontInfo.sForeground, fontSize:FontInfo.iFontSize+2, fontWeight:'bold', }}>Closed P&L</Text>
        <TextWithImage bindEvent={this.props.bindEvent}
        //onPress={()=>{this.props.qbRef?.current?.oOrderRef?.ShowSettings(false)}}
        Sample_Image={()=>{return(null) }}
        getStyle={()=>
        {
          return([FontInfo.appStyles.txt_bold, {color: ACC.GetPNLClosedColor(oData), fontSize:FontInfo.iFontSize+2}])
        }}
        getText={()=>{return( ACC.GetPNLClosedText(oData) )}}
        />


        {/*
        <Text style={{marginTop:5, color:'black', fontSize:12, fontWeight:'bold', }}>P&L (Closed)</Text>
        <Text2Eqv style={{color:'green', }}
                bindEvent={this.props.bindEvent}
                getText={()=>{ return(oData.pnl_closed) }}
                />

        <Text style={{marginTop:5, color:'black', fontSize:12, fontWeight:'bold', }}>Net Qty</Text>
        <Text2Eqv style={{color:'green', fontSize:14, fontWeight:'bold', }}
                bindEvent={this.props.bindEvent}
                getText={()=>{ return(oData.net_qty) }}
                />

        <Text style={{marginTop:5, color:'black', fontSize:12, fontWeight:'bold', }}> Open Orders (B/S)</Text>
        <Text2Eqv style={{color:'green', fontSize:14, fontWeight:'bold', }}
                bindEvent={this.props.bindEvent}
                getText={()=>{ return(oData.working_buys + " / " + oData.working_sells) }}
                />                           */}



        <View style={{backgroundColor:'transparent', minWidth:150, marginTop:5, flexDirection:'row', alignItems:'center', alignContent:'center', justifyContent:'center'}}>

        {/* <FontAwesome5 name="comment-dollar" size={13} color="gainsboro" />   */}
        <TextWithImage bindEvent={this.props.bindEvent}
            //onPress={()=>{this.props.qbRef?.current?.oOrderRef?.ShowSettings(false)}}
            Sample_Image={()=>{return(<Foundation name="dollar" size={18} color={ACC.GetPNLColor(oData)} />)}}
            getStyle={()=>
              {
                return([FontInfo.appStyles.txt_bold, {color: ACC.GetPNLColor(oData), fontSize:FontInfo.iFontSize+2 }])
              }}
              getText={()=>{return( ACC.GetPNLText(oData) )}}
              />

          <TextWithImage bindEvent={this.props.bindEvent}
            //onPress={this.props.qbRef?.current?.oOrderRef?.ShowSymbolProps}
            Sample_Image={()=>{return(<FontAwesome5 style={{marginLeft:6, marginTop:-2}} name="shopping-bag" size={12} color={ACC.GetPosColor(oData)} />)}}
            getStyle={()=>
              {
                return([FontInfo.appStyles.txt_bold, {color: ACC.GetPosColor(oData), fontSize:FontInfo.iFontSize+2 }])
              }}

            getText={()=> { return( ACC.GetPosText(oData) ) }}
            />

        <TextWithImage bindEvent={this.props.bindEvent}
          //onPress={this.props.qbRef?.current?.oOrderRef?.ShowSymbolProps}
          Sample_Image={()=>{return(<Feather style={{marginLeft:4}} name="shopping-cart" size={12} color={ACC.GetOrdColor(oData)} />)}}
          getStyle={()=>{ return(
            [FontInfo.appStyles.txt_bold, {color:ACC.GetOrdColor(oData), fontSize:FontInfo.iFontSize+2}]
                                )}}
          getText={()=>{return( ACC.GetOrderText(oData))}}
          />

        </View>



        </View>


        <View style={this.state.exit_conf_acc==oData.acc_id && !this.state.exit_all?
          {backgroundColor:'transparent',  } : {display:'none'}}>
        <Text style={[FontInfo.appStyles.txt_normal, {alignSelf:'center', position:'absolute', bottom:0, fontSize: FontInfo.iFontSize, color:'white'}]}>Tap again to confirm</Text>
        </View>

        </View>
        );
        }
        )

        }

        </View>
      </ScrollView>
       

      <View style={{ flexDirection:'row', alignSelf:'flex-end', alignItems:'center', justifyContent:'center', width:'100%', 
                     borderBottomEndRadius:25, backgroundColor:'rgba(94,94,94,.8)'}}>
      {/* <View style={{marginLeft:20, flexDirection:'column', alignSelf:'center', justifyContent:'center', backgroundColor:'transparent'}}> */}
      <View style={{marginLeft:20, flexDirection:'column', alignSelf:'center', justifyContent:'center', backgroundColor:'transparent'}}>
        
      <TouchableOpacity
      style={[{marginTop:8, marginBottom:8, marginRight:0, width:60, height:60, borderRadius:30, alignSelf:'center', 
              alignItems:'center', alignContent:'center', justifyContent:'center', 
              backgroundColor:this.state.exit_all? "#ff355e":FontInfo.bDarkMode? FontInfo.sGrayTp : FontInfo.sBorder,
              }]}

      onPress={()=>
          {
          if (this.state.exit_all)
            {

            for (let [key, oData] of Connection.oAccStore.entries())
              {
              ConnectionOrd.oConn?.Rq_CancelAllOrdersAcc(oData.key, "Main Menu, Cncl All & Fltn Button, All")
              ConnectionOrd.oConn?.Rq_ExitPositionAcc(oData.key, "Main Menu, Cncl All & Fltn Button, All");
              }

            this.setState({exit_conf_acc: undefined, exit_all:false});
            }
          else
            {
            this.setState({exit_conf_acc: undefined, exit_all:true});
            this.Reset();
            }
          }}
      >
      <FontAwesome style={{marginLeft:2}} name="close" size={26} color={this.state.exit_all? 'white':"#ff355e"} />
      </TouchableOpacity>
      </View>
      </View>



      </View>
      );

     }
}